import { render, staticRenderFns } from "./onboarding-order-preferences.vue?vue&type=template&id=47034bcb&scoped=true&"
import script from "./onboarding-order-preferences.vue?vue&type=script&lang=js&"
export * from "./onboarding-order-preferences.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-order-preferences.vue?vue&type=style&index=0&id=47034bcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47034bcb",
  null
  
)

export default component.exports